(function () {
  'use strict';

  var form = document.getElementById('receive_offer_form');
  if (!form) return;

  var card = document.querySelector('[data-form-card]');
  var steps = Array.prototype.slice.call(document.querySelectorAll('[data-step]'));
  var currentStepLabel = document.querySelector('[data-current-step]');
  var progress = document.querySelector('[data-progress]');
  var consumption = document.querySelector('[data-consumption]');
  var consumptionOptions = document.querySelector('[data-consumption-options]');
  var purchase = document.querySelector('[data-purchase]');
  var submitButton = form.querySelector('.submit-btn');
  var currentStep = 1;

  var consumptionSets = {
    Lavazza: [
      { value: '5', label: '5 / jour' },
      { value: '10', label: '10 / jour' },
      { value: '+10', label: '+ de 10 / jour' },
      { value: '+40', label: '+ de 40 / jour' }
    ],
    Bravilor: [
      { value: '20', label: '20 / jour' },
      { value: '30', label: '30 / jour' },
      { value: '40', label: '40 à 50' },
      { value: '+50', label: '+ de 50' }
    ]
  };

  function storeTracking() {
    try {
      var params = new URLSearchParams(window.location.search);
      var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_adgroup', 'oppref'];
      var tracking = {};
      var hasTracking = false;

      keys.forEach(function (key) {
        var value = params.get(key);
        if (value) {
          tracking[key] = value;
          hasTracking = true;
        }
      });

      if (hasTracking) {
        tracking.landing_page = window.location.pathname + window.location.search;
        tracking.referrer = document.referrer || '';
        tracking.tracked_at = new Date().toISOString();
        localStorage.setItem('edipsamatic_acquisition', JSON.stringify(tracking));
      }
    } catch (error) {
      console.warn('Tracking non disponible', error);
    }
  }

  function hydrateTracking() {
    try {
      var raw = localStorage.getItem('edipsamatic_acquisition');
      if (!raw) return;
      var tracking = JSON.parse(raw);
      var trackedAt = tracking.tracked_at ? new Date(tracking.tracked_at) : null;
      var maxAge = 7 * 24 * 60 * 60 * 1000;

      if (!trackedAt || isNaN(trackedAt.getTime()) || Date.now() - trackedAt.getTime() > maxAge) {
        localStorage.removeItem('edipsamatic_acquisition');
        return;
      }

      var mapping = {
        utm_source: 'tracking_utm_source',
        utm_medium: 'tracking_utm_medium',
        utm_campaign: 'tracking_utm_campaign',
        utm_content: 'tracking_utm_content',
        utm_term: 'tracking_utm_term',
        utm_adgroup: 'tracking_utm_adgroup',
        oppref: 'tracking_oppref',
        landing_page: 'tracking_landing_page',
        tracked_at: 'tracking_date'
      };

      Object.keys(mapping).forEach(function (key) {
        var field = document.getElementById(mapping[key]);
        if (field) field.value = tracking[key] || '';
      });
    } catch (error) {
      console.warn('Acquisition non disponible', error);
    }
  }

  function showStep(number) {
    currentStep = number;
    steps.forEach(function (step) {
      var active = Number(step.getAttribute('data-step')) === number;
      step.hidden = !active;
      step.classList.toggle('is-active', active);
    });
    currentStepLabel.textContent = String(number);
    progress.style.width = (number / 3 * 100) + '%';
    var firstFocusable = document.querySelector('[data-step="' + number + '"] input:not([type="hidden"])');
    if (firstFocusable && number > 1) window.setTimeout(function () { firstFocusable.focus({ preventScroll: true }); }, 50);
  }

  function setError(message) {
    var step = document.querySelector('[data-step="' + currentStep + '"]');
    var error = step.querySelector('[data-step-error]');
    error.textContent = message || '';
  }

  function checked(name) {
    return form.querySelector('input[name="' + name + '"]:checked');
  }

  function validateStep() {
    setError('');
    if (currentStep === 1 && !checked('secteur')) {
      setError('Choisissez votre type d’établissement.');
      return false;
    }
    if (currentStep === 2) {
      var offer = checked('offer');
      var consos = checked('consos');
      if (!offer) {
        setError('Choisissez une solution café.');
        return false;
      }
      if (!consos) {
        setError('Indiquez votre consommation quotidienne.');
        return false;
      }
      if (consos.value === '+50') {
        setError('Pour plus de 50 cafés par jour, appelez-nous afin de recevoir une étude personnalisée.');
        return false;
      }
      if (offer.value === 'Bravilor' && !checked('achat_loa')) {
        setError('Choisissez la location ou l’achat.');
        return false;
      }
    }
    if (currentStep === 3) {
      var required = Array.prototype.slice.call(document.querySelectorAll('[data-step="3"] input[required]'));
      for (var i = 0; i < required.length; i += 1) {
        if (!required[i].checkValidity()) {
          required[i].reportValidity();
          setError('Vérifiez les informations renseignées.');
          return false;
        }
      }
    }
    return true;
  }

  function renderConsumption(offer) {
    consumptionOptions.innerHTML = '';
    var options = consumptionSets[offer] || [];
    options.forEach(function (option) {
      var label = document.createElement('label');
      label.className = 'lp-choice';
      label.innerHTML = '<input type="radio" name="consos" value="' + option.value + '" required><span class="lp-choice__icon" aria-hidden="true">☕</span><span>' + option.label + '</span>';
      consumptionOptions.appendChild(label);
    });
    consumption.hidden = options.length === 0;

    var purchaseInputs = purchase.querySelectorAll('input');
    var needsPurchase = offer === 'Bravilor';
    purchase.hidden = !needsPurchase;
    Array.prototype.forEach.call(purchaseInputs, function (input) {
      input.disabled = !needsPurchase;
      input.required = needsPurchase;
      if (!needsPurchase) input.checked = false;
    });
  }

  form.addEventListener('change', function (event) {
    if (event.target.name === 'offer') renderConsumption(event.target.value);
    if (event.target.name === 'secteur') {
      try { sessionStorage.setItem('secteur', event.target.value); } catch (error) {}
    }
    setError('');
  });

  form.addEventListener('click', function (event) {
    var next = event.target.closest('[data-next]');
    var back = event.target.closest('[data-back]');
    if (next) {
      if (validateStep()) showStep(Math.min(3, currentStep + 1));
    }
    if (back) showStep(Math.max(1, currentStep - 1));
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!validateStep()) return;

    submitButton.disabled = true;
    submitButton.firstChild.nodeValue = 'Envoi en cours… ';

    fetch(form.action, { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = {};
          try { data = JSON.parse(text); } catch (error) { throw new Error('Réponse du serveur inattendue. Veuillez nous contacter pour vérifier votre demande.'); }
          if (!data || typeof data !== 'object' || !response.ok || data.success === false || data.icon === 'error' || data.icon === 'warning') throw new Error((data && data.message) || 'Une erreur est survenue.');
          return data;
        });
      })
      .then(function () {
        try { sessionStorage.setItem('receiveOfferSentAt', new Date().toISOString()); } catch (error) {}
        var redirected = false;
        function goToConfirmation() {
          if (redirected) return;
          redirected = true;
          window.location.assign('/pages/demande-confirmee');
        }
        window.setTimeout(goToConfirmation, 1200);
        if (window.gtag) {
          window.gtag('event', 'generate_lead', {
            event_category: 'ChatGPT Ads',
            event_callback: goToConfirmation,
            event_timeout: 1000
          });
        } else {
          goToConfirmation();
        }
      })
      .catch(function (error) {
        setError(error.message || 'Impossible d’envoyer votre demande. Réessayez ou appelez-nous.');
        submitButton.disabled = false;
        submitButton.firstChild.nodeValue = 'Recevoir mon offre ';
      });
  });

  storeTracking();
  hydrateTracking();

  try {
    var savedSector = sessionStorage.getItem('secteur');
    if (savedSector) {
      var sectorInput = form.querySelector('input[name="secteur"][value="' + savedSector + '"]');
      if (sectorInput) sectorInput.checked = true;
    }
  } catch (error) {}

  showStep(1);
})();
